export default __webpack_public_path__ + "static/funders-esip-5d4f533313d35d2a92c32d5584a1a9e0.png";